import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type ContainerStationBasicInfoFragment = { __typename?: 'ContainerStation', id: string, name: string, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null } };

export const ContainerStationBasicInfoFragmentDoc = gql`
    fragment ContainerStationBasicInfo on ContainerStation {
  id
  name
  item_type {
    id
    name
    color_hex_code
    category
    epc_asset_id
    image_url
  }
}
    `;